import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";

export const bookingsApiSlice = createApi({
  reducerPath: "bookingsApiSlice",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["bookingSummary", "bookingsByUserToken", "verifyPaymentParcel"],
  endpoints: (builder) => ({
    getUserOrder: builder.query({
      query: ({ orderIds }) => {
        return {
          url: `/orders/${orderIds}?include-group=true&createdBy=any`,
        };
      },
      providesTags: ["bookingSummary"],
    }),
    // Postpay contract conclusion (#1701/#1702). `order/` is SINGULAR — API
    // Gateway allows one path-parameter name per position and `orders/{orderIds}`
    // above already owns that slot, so the backend nests this under `order/`.
    // The token is sent in the BODY, never the query string: it concludes a
    // contract, and query strings end up in logs and referrers.
    acceptOrder: builder.mutation({
      query: ({ orderId, token }: { orderId: string; token: string }) => ({
        url: `/order/${orderId}/accept`,
        method: "POST",
        data: { token },
      }),
      // The booking becomes `booked` on acceptance, so any cached summary that
      // still says `reserviert` must go.
      invalidatesTags: ["bookingSummary"],
    }),
    getOrdersByToken: builder.query({
      query: ({}) => {
        return {
          url: `/orders/user?include-group=true&createdBy=any`,
        };
      },
      providesTags: ["bookingsByUserToken"],
    }),
    openDoorParcelRetrieval: builder.mutation({
      // Corrected to accept data as argument and use POST method
      query: (reservationId: string) => {
          return {
              url: `/open/door/parcel/retrieval`,
              method: "POST",
              data: {
                reservationIds: [reservationId] 
              },
          };
      },
      // Opening the parcel door completes retrieval; refresh verifyPayment.
      invalidatesTags: ["verifyPaymentParcel"],
    }),
    verifyPayment: builder.query({
      query: ({ reservationId }) => {
        return {
          url: `/parcel/retrieval/${reservationId}`,
        };
      },
      providesTags: ["verifyPaymentParcel"],
    }),
  }),
});

export const {
  useGetUserOrderQuery,
  useGetOrdersByTokenQuery,
  useLazyGetUserOrderQuery,
  useVerifyPaymentQuery,
  useOpenDoorParcelRetrievalMutation,
  useAcceptOrderMutation,
} = bookingsApiSlice;
